import "./VideoComponent.scss";
import React from "react";

const App = ({ handleSkip }) => {
  const delaySkip = async () => {
    // await new Promise((resolve) => setTimeout(resolve, 1200));
    handleSkip();
  };

  return (
    <>
      <div className="videoContainer">
        <video className="videoContent" autoPlay onEnded={delaySkip}>
          <source src="assets/VideoPromo_AlaM_01.mp4" type="video/mp4" />
          Your browser does not support HTML video.
        </video>
        <div className="skip" onClick={delaySkip}>
          <p>SKIP</p>
        </div>
      </div>
      <div className={`fader out`} />
    </>
  );
};

export default App;
